export default "__VITE_ASSET__1ad27233__"